// extracted by mini-css-extract-plugin
export var footer = "_oc-5";
export var fulfillmentInput = "_oc-0";
export var shipDateInput = "_oc-1";
export var shipmentModal = "_oc-2";
export var shipmentModalContent = "_oc-3";
export var tableContainer = "_oc-4";